module.exports = __webpack_public_path__ + "static/img/Logo_Affixe2.0.4988570.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connexionPage/Logo_Affixe2.0.svg
// module id = WZjR
// module chunks = 1